import { APP_MODE_PLATFORM, ROLE_ADMIN, ROLE_AGENT, ROLE_CLIENT, ROLE_MANAGER } from '@/consts/app'
import store from '@/store'
import { $ui } from '@/utils/ui'
import { ROUTE_NAME_PLATFORM_DASHBOARD } from '@/router/platform'
import {
  ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF,
  ROUTE_NAME_TERRAIN_PLANNING,
  ROUTE_NAME_TERRAIN_RONDE_SECU,
  ROUTE_NAME_TERRAIN_SERVICE_ACTIF
} from '@/router/terrain'
import platform from './platform'
import terrain from './terrain'
import {
  ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS,
  ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE,
  ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE
} from '@/consts/rights'

// Pages
const Index = () => import(/* webpackChunkName: "app-main" */'pages/Index')
const Error404 = () => import(/* webpackChunkName: "app-main" */'pages/Error404')
const SimpleRouteWrapper = () => import(/* webpackChunkName: "app-main" */'@/router/SimpleRouteWrapper')
const ParamsTerrain = () => import(/* webpackChunkName: "app-main" */'pages/Platform/Params/ParamsTerrain')
const ParamsAgency = () => import(/* webpackChunkName: "app-main" */'pages/Platform/Params/ParamsAgency')
const ParamsEmailExport = () => import(/* webpackChunkName: "app-main" */'pages/Platform/Params/ParamsEmailExport')
const ParamsContracts = () => import(/* webpackChunkName: "app-main" */'pages/Platform/Params/ParamsContracts')
const ParamsCommercialDocs = () => import(/* webpackChunkName: "app-main" */'pages/Platform/Params/ParamsCommercialDocs')
const ApplicationsLinks = () => import(/* webpackChunkName: "app-main" */'pages/ApplicationsLinks')
const Shop = () => import(/* webpackChunkName: "app-main" */'pages/Shop')
const Sponsor = () => import(/* webpackChunkName: "app-main" */'pages/Sponsor')
const SiteOffer = () => import(/* webpackChunkName: "app-main" */'pages/SiteOffer')
const User = () => import(/* webpackChunkName: "app-main" */'pages/User')
const About = () => import(/* webpackChunkName: "app-main" */'pages/About')
const Tutorial = () => import(/* webpackChunkName: "app-main" */'pages/Tutorial')
const Payments = () => import(/* webpackChunkName: "app-main" */'pages/Payments')
const Subscriptions = () => import(/* webpackChunkName: "app-main" */'pages/Subscriptions')
const ChoosePlan = () => import(/* webpackChunkName: "sekur-main" */'pages/ChoosePlan')
const ContactAgence = () => import(/* webpackChunkName: "app-main" */'pages/Terrain/ContactAgence')
// Pages admin
const Agencies = () => import(/* webpackChunkName: "app-admin-main" */'pages/Admin/Agencies')
const AdminPayments = () => import(/* webpackChunkName: "app-admin-main" */'pages/Admin/Payments')
const AdminUsers = () => import(/* webpackChunkName: "app-admin-main" */'pages/Admin/Users')
const AdminFeedbacks = () => import(/* webpackChunkName: "app-admin-main" */'pages/Admin/Feedbacks')

export const ROUTE_NAME_PARAMS_MAIL_EXPORT = 'paramsEmailExport'
export const ROUTE_NAME_HOME = 'home'
export const ROUTE_NAME_USER = 'user'
export const ROUTE_NAME_AGENCY = 'agency'
export const ROUTE_NAME_PAYMENTS = 'payments'
export const ROUTE_NAME_SUBSCRIPTIONS = 'subscriptions'
export const ROUTE_NAME_CHOOSE_PLAN = 'choosePlan'
export const ROUTE_PARAMS_AGENCY = 'paramsAgency'
export const ROUTE_NAME_LINKS = 'liensUtiles'
export const ROUTE_NAME_ADMINISTRATOR = 'administration'
export const ROUTE_NAME_PARAMS = 'params'
export const ROUTE_NAME_CONTRACT_TEMPLATES = 'contractTemplates'
const routes = [
  {
    path: '',
    name: 'main',
    redirect: () => {
      if (!store.getters['user/isLoggedIn']) {
        return {
          name: ROUTE_NAME_HOME
        }
      }
      if (store.getters['service/rondeActive']) {
        return { name: ROUTE_NAME_TERRAIN_RONDE_SECU }
      }
      if (store.getters['service/serviceActif']) {
        return {
          name: store.getters['service/isCircuit']
            ? ROUTE_NAME_TERRAIN_CIRCUIT_ACTIF
            : ROUTE_NAME_TERRAIN_SERVICE_ACTIF
        }
      }
      const name = $ui.leftDrawerNav === APP_MODE_PLATFORM
        ? store.getters['user/isManager']
          ? ROUTE_NAME_PLATFORM_DASHBOARD
          : ROUTE_NAME_TERRAIN_PLANNING
        : ROUTE_NAME_TERRAIN_PLANNING
      return {
        name
      }
    }
  },
  {
    path: 'home',
    name: 'home',
    component: Index
  },
  {
    path: 'user',
    name: ROUTE_NAME_USER,
    component: User
  },
  // {
  //   path: 'agency',
  //   name: ROUTE_NAME_AGENCY,
  //   component: AgencyShow
  // },
  {
    path: 'payments',
    name: ROUTE_NAME_PAYMENTS,
    component: Payments
  },
  {
    path: 'subscriptions',
    name: ROUTE_NAME_SUBSCRIPTIONS,
    component: Subscriptions
  },
  {
    path: 'plan_options',
    name: ROUTE_NAME_CHOOSE_PLAN,
    component: ChoosePlan
  },
  // Routes spécifiques à l'admin
  {
    path: 'adminAgencies',
    name: 'platformAdminAgencies',
    component: Agencies,
    meta: {
      label: 'Agences',
      icon: 'fa fa-city',
      roles: [ROLE_ADMIN]
    }
  },
  ...terrain,
  ...platform,
  {
    path: 'params',
    name: ROUTE_NAME_PARAMS,
    component: SimpleRouteWrapper,
    meta: {
      label: 'Paramètres',
      group: true,
      icon: 'fa fa-cogs',
      roles: [ROLE_MANAGER, ROLE_AGENT],
      mode: ['platform']
    },
    children: [
      {
        path: 'agency',
        name: ROUTE_PARAMS_AGENCY,
        component: ParamsAgency,
        meta: {
          isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS],
          label: 'Agence',
          icon: 'fa fa-cog',
          mode: ['platform']
        }
      },
      {
        path: 'field',
        name: 'paramsTerrain',
        component: ParamsTerrain,
        meta: {
          isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS],
          label: 'Terrain',
          icon: 'fa fa-cog',
          mode: ['platform']
        }
      },
      {
        path: 'commercial-docs',
        name: 'paramsCommercialDocs',
        component: ParamsCommercialDocs,
        meta: {
          isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS],
          label: 'Devis & Factures',
          icon: 'fa fa-cog',
          mode: ['platform']
        }
      },
      {
        path: 'emailExport',
        name: ROUTE_NAME_PARAMS_MAIL_EXPORT,
        component: ParamsEmailExport,
        meta: {
          isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS],
          label: 'Email & export',
          icon: 'fa fa-cog',
          mode: ['platform']
        }
      },
      {
        path: 'contractTemplates',
        name: ROUTE_NAME_CONTRACT_TEMPLATES,
        component: ParamsContracts,
        meta: {
          isGranted: [
            ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_CUSTOMER_TEMPLATE,
            ACCOUNT_RIGHT_LIST_AGENCY_CONTRACT_AGENT_TEMPLATE
          ],
          label: 'Contrats',
          icon: 'fa fa-cog',
          mode: ['platform']
        }
      }
    ]
  },
  {
    path: 'administration',
    name: ROUTE_NAME_ADMINISTRATOR,
    component: SimpleRouteWrapper,
    meta: {
      label: 'Administration',
      group: true,
      roles: [ROLE_ADMIN],
      icon: 'fa fa-crown'
    },
    children: [
      {
        path: 'adminPayments',
        name: 'adminPayments',
        component: AdminPayments,
        meta: {
          label: 'Paiements',
          icon: 'fa fa-cash-register',
          roles: [ROLE_ADMIN]
        }
      },
      {
        path: 'adminUsers',
        name: 'adminUsers',
        component: AdminUsers,
        meta: {
          label: 'Utilisateurs',
          icon: 'fa fa-users-cog',
          roles: [ROLE_ADMIN]
        }
      },
      {
        path: 'adminFeedbacks',
        name: 'adminFeedbacks',
        component: AdminFeedbacks,
        meta: {
          label: `Demandes d'améliorations`,
          icon: 'fas fa-comment-dots',
          roles: [ROLE_ADMIN]
        }
      }
    ]
  },
  {
    path: 'liensUtiles',
    name: ROUTE_NAME_LINKS,
    component: SimpleRouteWrapper,
    meta: {
      label: 'Liens utiles',
      group: true,
      roles: [ROLE_AGENT, ROLE_MANAGER],
      icon: 'fa fa-link'
    },
    children: [
      {
        path: 'import',
        name: 'platformLiensUtilesImport',
        meta: {
          label: 'Importer vos données',
          icon: 'fa fa-cloud-upload-alt',
          roles: [ROLE_MANAGER],
          mode: ['platform']
        }
      },
      {
        path: 'app',
        name: 'platformDocumentsApp',
        component: ApplicationsLinks,
        meta: {
          label: 'Application Android™ / IPhone™',
          icon: 'fa fa-mobile-alt'
        }
      },
      {
        path: 'shop',
        name: 'platformShop',
        component: Shop,
        meta: process.env.APP.app.showModules.shop
          ? {
            label: 'Boutique',
            icon: 'fa fa-shopping-cart',
            roles: [ROLE_MANAGER]
          }
          : null
      },
      {
        path: 'packCommunication',
        name: 'platformDocumentsPackCommunication',
        meta: process.env.APP.app.showModules.packCommunication
          ? {
            label: 'Pack communication',
            icon: 'fa fa-bullhorn',
            roles: [ROLE_MANAGER]
          }
          : null
      },
      {
        path: 'parrainage',
        name: 'platformDocumentsParrainage',
        component: Sponsor,
        meta: process.env.APP.app.showModules.parrainage
          ? {
            label: 'Offre de parrainage',
            icon: 'fa fa-gift',
            roles: [ROLE_MANAGER]
          }
          : null
      },
      {
        path: 'offreSite',
        name: 'platformDocumentsOffreSite',
        component: SiteOffer,
        meta: process.env.APP.app.showModules.offreSite
          ? {
            label: 'Offre de site internet',
            icon: 'fa fa-globe',
            roles: [ROLE_MANAGER]
          }
          : null
      },
      {
        path: 'about',
        name: 'about',
        component: About,
        meta: process.env.APP.app.showModules.about
          ? {
            label: `À propos de ${process.env.APP.name}`,
            icon: 'fa fa-question'
          }
          : null
      },
      {
        path: 'tutorial',
        name: 'tutorial',
        component: Tutorial,
        meta: {
          label: 'Tutoriel',
          icon: 'fa fa-chalkboard-teacher'
        }
      }
    ]
  },
  {
    path: 'terrain/contactAgence',
    name: 'terrainContactAgence',
    component: ContactAgence,
    meta: {
      label: 'Contacter l\'agence',
      icon: 'fa fa-phone',
      roles: [ROLE_AGENT, ROLE_CLIENT]
    }
  },
  {
    path: 'app-agent',
    name: 'appAgent',
    component: ApplicationsLinks,
    meta: {
      label: 'Application Android™ / IPhone™',
      icon: 'fa fa-mobile-alt',
      roles: [ROLE_CLIENT]
    }
  },
  {
    path: '*',
    component: Error404
  }
]

export default routes
